import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import services from "../content/services";

const Caps = ({ limit }) => {
  const list = limit ? services.slice(0, limit) : services;
  return (
    <div className="caps">
      {list.map((s) => (
        <Link key={s.slug} to={`/services/${s.slug}`} className="cap">
          <div className="code">{s.code}</div>
          <h3>{s.title}</h3>
          <p>{s.blurb}</p>
          <span className="more">READ MORE <FiArrowUpRight /></span>
        </Link>
      ))}
    </div>
  );
};

export default Caps;
